<div>
  <p class="text-green-700">Multiple Selections</p>
  @for (o of currentQuestion.QuestionAnswers; track o) {
    <div>
      <div class="border-[2px] rounded-md border-solid w-full py-1 px-2 my-2 hover:cursor-pointer"
        [ngClass]="{'bg-green-300 text-standardwhite border-offblack':o.Selected}" (click)="selectOption(o)">
        <p>{{o.AnswerText}}</p>
      </div>
    </div>
  }
</div>